import '.d1{width:auto;}.ssr-plugin'
import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'
import { SelectInput } from '../SelectInput/index.js'
import { useBasedSchema } from '../../providers/Endpoints/index.js'
import { styled } from 'inlines'
import { capitalize } from '../../utils/text.js'
import useLocalStorage from '@based/use-local-storage'

const LanguageCtx = createContext<[string, Dispatch<string>]>(['en', () => {}])

export const useLanguage = () => useContext(LanguageCtx)

export const LanguageProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [storageActiveLanguage, setStorageActiveLanguage] =
    useLocalStorage('language')
  const state = useState<string>(storageActiveLanguage ?? 'en')

  useEffect(() => {
    if (!state[0]) {
      return
    }

    setStorageActiveLanguage(state[0])
  }, [state[0]])

  return <LanguageCtx.Provider value={state}>{children}</LanguageCtx.Provider>
}

const cache: Record<string, string> = {}
const names = new Intl.DisplayNames(['en'], { type: 'language' })

export const getLanguageName = (langCode: string) => {
  if (!(langCode in cache)) {
    const name = names.of(langCode) || ''
    cache[langCode] = capitalize(name)
  }
  return cache[langCode]
}

export const LanguageSelect = () => {
  const [lang, setLang] = useLanguage()
  const { data } = useBasedSchema()
  if (!data?.locales) {
    return null
  }
  return (
    <div className="d1">
      <SelectInput
        unclearable
        ghost
        value={lang}
        options={Object.keys(data.locales).map((value) => ({
          value,
          label: getLanguageName(value),
        }))}
        onChange={(val) => setLang(String(val))}
        style={{ width: 'auto', maxWidth: 'auto' }}
      />
    </div>
  )
}
